import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorNotificationService } from '../services/implementations/error.notification.service';

@Injectable()
export class HttpInterceptorErrorNotification implements HttpInterceptor {

    constructor(private errorNotificationService: ErrorNotificationService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error instanceof HttpErrorResponse) {
                    // Extract operation from URL and method
                    const operation = this.extractOperationFromRequest(request);
                    
                    // Show error notification
                    this.errorNotificationService.showHttpError(
                        error.status,
                        operation,
                        request.url
                    );
                }

                // Re-throw the error so existing error handling still works
                return throwError(error);
            })
        );
    }

    private extractOperationFromRequest(request: HttpRequest<any>): string {
        const method = request.method.toLowerCase();
        const url = request.url.toLowerCase();

        // Determine operation based on HTTP method and URL patterns
        switch (method) {
            case 'post':
                return 'save';
            case 'put':
                return 'update';
            case 'delete':
                return 'delete';
            case 'get':
                if (url.includes('getall') || url.includes('list')) {
                    return 'load';
                } else if (url.includes('getbyid') || url.includes('details')) {
                    return 'load';
                } else {
                    return 'load';
                }
            default:
                return method;
        }
    }
}